declare global {
  interface Window {
    Cookiebot?: {
      consent?: {
        statistics?: boolean;
      };
    };
  }
}

/**
 *
 * @returns Cookiebot statistics consent status
 */
export function getCookieBotConsentStatistics(): boolean {
  const cookiebot = (globalThis as unknown as Window).Cookiebot;
  return Boolean(cookiebot?.consent?.statistics);
}
